import React, { useEffect } from 'react';
import TimerCountdownController from './controllers/TimerCountdownController';
import TimerController from './controllers/TimerController';
import classNames from 'classnames';
import styles from './Timer.module.css';
import { MINUTE } from '../../../utils/time';
import {
  ApplicationView,
  StartControllerScope,
  useController,
} from '@aha-app/mvc';

const TimerCountdown: React.FC = () => {
  const controller = useController(TimerCountdownController);
  const timerController = useController(TimerController);
  const widget = controller.state.widget;

  const paused = widget.paused();
  const expired =
    widget.expired() || (!widget.active() && timerController.state.active);

  const counting = widget.active() && !paused && !expired;

  useEffect(() => {
    if (!counting) return;

    const countdown = setInterval(() => {
      controller.actionUpdateRemainingDuration();
    }, 1000);

    return () => clearInterval(countdown);
  }, [counting]);

  return (
    <>
      <div className={styles.leftPanel}>
        {expired ? (
          <>
            <i
              className={classNames(
                styles.alarm,
                styles.red,
                'fa-regular',
                'fa-alarm-clock'
              )}
            />
            <div
              className={classNames(
                styles.timerText,
                styles.red,
                styles.timeUp
              )}
            >
              Time is up
            </div>
          </>
        ) : (
          <>
            <div
              className={classNames(styles.timerText, {
                [styles.paused]: paused,
                [styles.orange]: widget.warningTime(),
                [styles.red]: widget.dangerTime(),
              })}
            >
              {controller.state.remainingDurationText}
            </div>
            <div className={styles.activeControls}>
              <div
                className={styles.addTimeButton}
                onClick={() => controller.actionAddTime(MINUTE)}
              >
                +1m
              </div>
              <div
                className={styles.addTimeButton}
                onClick={() => controller.actionAddTime(5 * MINUTE)}
              >
                +5m
              </div>
            </div>
          </>
        )}
      </div>
      <div className={styles.rightPanel}>
        {expired ? null : (
          <>
            {paused ? (
              <div
                className={styles.pauseButton}
                onClick={() => controller.actionUnpauseTimer()}
              >
                Resume
              </div>
            ) : (
              <div
                className={styles.pauseButton}
                onClick={() => controller.actionPauseTimer()}
              >
                Pause
              </div>
            )}
          </>
        )}

        <div
          className={styles.stopButton}
          onClick={() => controller.actionStopTimer()}
        >
          {expired ? 'Reset' : 'Stop'}
        </div>
      </div>
    </>
  );
};

const ControlledTimerCountdown = StartControllerScope(
  TimerCountdownController,
  ApplicationView(TimerCountdown)
);

export default ControlledTimerCountdown;
